interface WorldWithSchemeSVGProps {
  color: string;
  style: React.CSSProperties;
}

const WorldWithSchemeSVG = ({ color, style }: WorldWithSchemeSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="37"
    height="51"
    viewBox="0 0 37 51"
    fill="none"
  >
    <g clipPath="url(#clip0_519_19572)">
      <path
        d="M6.44623 46.4629H4.34436C3.78847 46.4629 3.33783 46.9135 3.33783 47.4694V49.5713C3.33783 50.1272 3.78847 50.5778 4.34436 50.5778H6.44623C7.00212 50.5778 7.45276 50.1272 7.45276 49.5713V47.4694C7.45276 46.9135 7.00212 46.4629 6.44623 46.4629Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2795 46.4629H17.1776C16.6217 46.4629 16.1711 46.9135 16.1711 47.4694V49.5713C16.1711 50.1272 16.6217 50.5778 17.1776 50.5778H19.2795C19.8354 50.5778 20.286 50.1272 20.286 49.5713V47.4694C20.286 46.9135 19.8354 46.4629 19.2795 46.4629Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.1054 46.4629H30.0035C29.4476 46.4629 28.9969 46.9135 28.9969 47.4694V49.5713C28.9969 50.1272 29.4476 50.5778 30.0035 50.5778H32.1054C32.6612 50.5778 33.1119 50.1272 33.1119 49.5713V47.4694C33.1119 46.9135 32.6612 46.4629 32.1054 46.4629Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2286 35.9756V40.2903"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2286 46.4624V40.29"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0618 46.4632V42.8515C31.0618 41.5045 29.9665 40.4092 28.6195 40.4092H7.83761C6.49064 40.4092 5.39529 41.5045 5.39529 42.8515V46.4632"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1624 4.50693C27.4205 3.70022 28.9155 3.22656 30.5215 3.22656C32.1276 3.22656 33.6225 3.70022 34.8807 4.50693"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7453 6.90381C29.256 6.57817 29.8629 6.38574 30.5141 6.38574C31.1654 6.38574 31.7723 6.57817 32.283 6.90381"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6992 9.03561C30.6992 9.13922 30.6178 9.22063 30.5141 9.22063C30.4105 9.22063 30.3291 9.13922 30.3291 9.03561C30.3291 8.932 30.4105 8.85059 30.5141 8.85059C30.6178 8.85059 30.6992 8.932 30.6992 9.03561Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5141 22.7055C33.5675 22.7055 36.0427 20.2303 36.0427 17.177C36.0427 14.1236 33.5675 11.6484 30.5141 11.6484C27.4608 11.6484 24.9856 14.1236 24.9856 17.177C24.9856 20.2303 27.4608 22.7055 30.5141 22.7055Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1384 17.1765C28.1384 15.8665 29.2042 14.8008 30.5141 14.8008C31.8241 14.8008 32.8898 15.8665 32.8898 17.1765"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.92337 16.0967H22.6617"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0971 2.84863V16.1111"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5141 22.7867V33.5255C30.5141 34.7097 29.552 35.6718 28.3679 35.6718H17.9177C16.9112 35.6718 16.0971 34.8577 16.0971 33.8512V16.0889"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.094 26.2064C25.2151 29.6182 20.9077 31.7941 16.0971 31.7941C7.43797 31.7941 0.414459 24.7706 0.414459 16.1115C0.414459 7.45237 7.43797 0.414062 16.0971 0.414062C19.1907 0.414062 22.0771 1.31698 24.5046 2.86378"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9073 2.84863C10.5316 5.05412 7.68959 9.19125 7.68959 16.3554"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2869 2.84863C21.2185 4.63966 23.461 7.70366 24.2307 12.6401"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8198 29.3593C21.3 27.8347 22.8616 25.5627 23.7571 22.2988"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3596 29.344C10.1171 27.0275 7.68959 22.994 7.68959 16.3701"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0971 9.36911C11.1236 9.36911 8.26686 7.87412 6.73486 6.59375"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.4519 6.60156C23.9199 7.87453 21.0631 9.36952 16.0971 9.36952"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.4519 25.6068C23.9199 24.3339 21.0631 22.8389 16.0971 22.8389"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.63126 25.6956C8.13365 24.4005 11.0126 22.8389 16.0897 22.8389"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_519_19572">
        <rect width="36.4571" height="51" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default WorldWithSchemeSVG;
